import { useRetrieveTitle } from "@/Utils/helpers";
import { LeftOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Radio } from "antd";
import classNames from "classnames";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import { getCookie } from "cookies-next";

interface HeaderProps {
  isNestedFleetsPage: boolean;
  isNestedServicePage: boolean;
  isNestedHistoryPage: boolean;
  isActivePath: string;
  direction: string;
  updateSearchQuery: (value: string) => void;
  setCapabilityModelOpen: (value: boolean) => void;
  setFleetModelOpen: (value: boolean) => void;
  serviceOptions: any;
  setServiceModalOpen: (value: boolean) => void;
}

const HeaderContent: React.FC<HeaderProps> = ({
  isNestedFleetsPage,
  isNestedServicePage,
  isNestedHistoryPage,
  isActivePath,
  setCapabilityModelOpen,
  setFleetModelOpen,
  updateSearchQuery,
  direction,
  serviceOptions,
  setServiceModalOpen,
}) => {
  const router = useRouter();
  const { getTitle } = useRetrieveTitle();
  const { serviceid, dispatchId, driverid } = useParams();
  const initialTab: any = useSearchParams().get("tab");
  const [activeTab, setActiveTab] = useState(initialTab || "map_view");
  const [label, setLabel] = useState();
  const hasAuthenticated = Boolean(getCookie("accessTokenDot"));

  useEffect(() => {
    if (initialTab === null && isActivePath === "/") {
      if (!hasAuthenticated) {
        router.push("/login");
        return;
      }
      setActiveTab("map_view");
      router.push("/?tab=map_view");
    } else if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab, isActivePath, router]);

  const handleTabChange = (e: any) => {
    const newTab = e.target.value;
    setActiveTab(newTab);
    router.push(`/?tab=${newTab}`);
  };

  const getLabelByValue = (value: any) => {
    const match = serviceOptions.find((item: any) => item.value === value);
    return match ? match.label : " ";
  };

  useEffect(() => {
    setLabel(getLabelByValue(serviceid));
  }, [serviceid, serviceOptions]);

  return (
    <>
      <div className={style.buttonsWrapper}>
        <LeftOutlined
          className={classNames({
            [style.arrowIcon]: true,
            [style.hide]:
              !isNestedServicePage &&
              !(isActivePath === `/services/${serviceid}`),
          })}
          onClick={() => router.back()}
        />
        <LeftOutlined
          className={classNames({
            [style.arrowIcon]: true,
            [style.hide]:
              !isNestedFleetsPage &&
              !(isActivePath === `/dispatch/${dispatchId}`),
          })}
          onClick={() => router.back()}
        />
        <LeftOutlined
          className={classNames({
            [style.arrowIcon]: true,
            [style.hide]:
              !isNestedHistoryPage &&
              !(isActivePath === `/history/${driverid}`),
          })}
          onClick={() => router.back()}
        />
        <LeftOutlined
          className={classNames(style.arrowIcon, {
            [style.hide]: isActivePath !== "/settings/profile",
          })}
          onClick={() => router.back()}
        />
        <p>
          {isActivePath === "/capabilities"
            ? getTitle("capabilities")
            : isActivePath === "/services"
              ? getTitle("service_management")
              : isActivePath === `/services/${serviceid}`
                ? label
                : isActivePath.includes("/fleets")
                  ? getTitle("fleet_management")
                  : isActivePath === "/dispatch" || isActivePath.includes("/dispatch")
                    ? getTitle("dispatch_management")
                    : isActivePath === "/"
                      ? getTitle("dashboard")
                      : isActivePath === `/history`
                        ? getTitle("dispatch_history")
                        : isActivePath === `/history/${driverid}`
                          ? getTitle("history_troubleshoot")
                          : isActivePath === "/settings"
                            ? getTitle("setting")
                            : isActivePath === "/settings/profile"
                              ? getTitle("profile")
                              : isActivePath === "/jobs"
                                ? getTitle("available_jobs")
                                : ""
          }
        </p>
        {isActivePath === `/services/${serviceid}` && (
          <Button
            className={style.btnConfiguration}
            onClick={() => setServiceModalOpen(true)}
          >
            {getTitle("create_configuration")}
          </Button>
        )}
        {isActivePath === "/capabilities" && (
          <Button
            className={style.btn}
            onClick={() => setCapabilityModelOpen(true)}
          >
            {getTitle("create_capabilities")}
          </Button>
        )}
        {isActivePath === "/fleets" && (
          <Button className={style.btn} onClick={() => setFleetModelOpen(true)}>
            {getTitle("create_fleet")}
          </Button>
        )}
      </div>

      {isActivePath === "/" && (
        <Radio.Group
          size="middle"
          optionType="button"
          buttonStyle="solid"
          onChange={handleTabChange}
          className={style.radioGroup}
          value={activeTab}
        >
          <Radio value="map_view">{getTitle("map_view")}</Radio>
          <Radio value="list_view">{getTitle("list_view")}</Radio>
        </Radio.Group>
      )}

      {isActivePath === "/fleets" && (
        <div className={style.search_wrapper}>
          <Input
            dir={direction}
            placeholder={getTitle("search_here")}
            size="middle"
            suffix={<SearchOutlined style={{ fontSize: "15px" }} />}
            onChange={({ target: { value } }) => updateSearchQuery(value)}
          />
        </div>
      )}
    </>
  );
};

export default HeaderContent;
